export const iconFontAwesomeMapsPrint = (
	<i className="fa-solid fa-print"></i>
);
